import StoryblokMenu from "./StoryblokMenu";

export default StoryblokMenu;
